import type { AxiosResponse } from 'axios'
import type {
  QueryUserLoginInfoParameters,
  QueryUserLoginInformationModel,
} from './model/userLoginInformationModel'

import { bffHTTP } from '@/utils/http/axios'
import { getErrorMessage } from '@/utils'

/**
 * @description ログイン情報取得 API
 * @param parameters
 * @returns
 */
export const queryUserLoginInformation = async ({
  corporateNumber,
  userID,
  roleCode,
}: QueryUserLoginInfoParameters): Promise<QueryUserLoginInformationModel | string> => {
  const failedMessage = getErrorMessage('EF9904')

  try {
    const { data, status }: AxiosResponse<QueryUserLoginInformationModel, any> =
      await bffHTTP({
        method: 'GET',
        url: `/0/users`,

        headers: {
          corporate_number: corporateNumber,
          user_id: userID,
          role_code: roleCode,
          timeout_message_code: 'EF9904',
        },
      })

    if (status !== 200) {
      return failedMessage
    }

    return data as QueryUserLoginInformationModel
  } catch (error) {
    console.log('queryUserLoginInformation', error)
    return failedMessage
  }
}
